<template>
    <table>
        <thead>
            <tr>
                <td>id</td>
                <td>lon</td>
                <td>lat</td>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(wp, index) in waypoints" v-on:click="deleteWaypoint(index)"  v-on:mouseover="wpOver(index)" v-on:mouseleave="wpLeave(index)">
                <td>{{index}}</td>
                <td>{{wp.lon}}</td>
                <td>{{wp.lat}}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>

export default {
    name: 'Waypoints',
    props: {
        waypoints: Array
    },
    methods: {
        deleteWaypoint: function (wpId){
            // var wpId = parseInt(event.target.id.replace('wp',''));
            this.waypoints.splice(wpId,1);
        },
        wpOver: function (wpId) {
            // console.log(event)
            // var wpId = parseInt(event.target.id.replace('wp',''));
            this.waypoints[wpId].c = '#0000ff';
        },
        wpLeave: function (wpId) {
            // var wpId = parseInt(event.target.id.replace('wp',''));
            this.waypoints[wpId].c = '#ff0000'
        }
    }
}

</script>
